import Dropdown from "../../../../dropdown/Dropdown";
import { useHistoryManager } from "../../../../history/useHistoryManager";
import {
  getOrganisation,
  setAccessPoint,
  setAccessPointId,
} from "../../../../slice/accessOrg-slice";
import { useAppDispatch, useAppSelector } from "../../../../slice/hooks";
import {
  getBasePath,
  getStorePath,
  setStorePath,
} from "../../../../slice/path-slice";

function BaseLocations({
  locations = [],
  accessPointId,
  handleLocationChange,
  className = "",
  dropdownThemeKey = "storeHeaderLocation",
}) {
  const dispatch = useAppDispatch();

  const storePath = useAppSelector(getStorePath);
  const basePath = useAppSelector(getBasePath);
  const { navigateTo } = useHistoryManager(storePath);

  const organisation = useAppSelector(getOrganisation);

  if (locations.length <= 1) return null;

  return (
    <Dropdown
      className={className}
      themeKey={dropdownThemeKey}
      options={locations}
      value={accessPointId}
      getOptionValue={(loc) => loc.accessPointId}
      getOptionLabel={(loc) => loc.name}
      onSelect={(option) => {
        const newLocation = option.name
          .trim()
          .replace(/\s+/g, "-")
          .replace(/[^a-zA-Z0-9-_]/g, "")
          .toLowerCase();

        const destination = `${basePath.replace(/\/+$/, "")}/${newLocation}`;

        navigateTo(destination, {
          urlData: {
            organisation,
            accessPoint: option.accessPoint,
            accessPoints: locations,
            accessPointId: option.accessPointId,
          },
          replace: true,
          onNavigate: (navigate) => {
            if (navigate) {
              dispatch(setAccessPointId(option.accessPointId));
              dispatch(setAccessPoint(option.accessPoint));
              handleLocationChange({ target: { value: option.accessPointId } });
              dispatch(setStorePath(destination));
            }
          },
        });
      }}
    />
  );
}

export default BaseLocations;
